import type { PaymentRailsTranslations } from "../interfaces/paymentRails";

export const paymentRailsTranslations: PaymentRailsTranslations = {
  // Page
  page_title: "Trilhos de pagamento",
  page_subtitle:
    "Mantenha cada trilho ativo ou coloque-o em manutenção, global ou por organização, sem deploys",
  refresh_button: "Atualizar",
  refresh_aria: "Atualizar o estado dos trilhos",
  why_banner:
    "Colocar um trilho em manutenção só bloqueia operações novas: payins e payouts em andamento continuam liquidando normalmente.",

  // Scope selector
  scope_label: "Escopo",
  scope_placeholder: "Buscar por nome, e-mail ou ID…",
  scope_loading: "Carregando organizações…",
  scope_empty: "Nenhuma organização encontrada.",
  scope_searching: "Buscando organizações…",
  scope_search_error: "Não foi possível concluir a busca; exibindo as organizações já carregadas.",
  scope_global_option: "Global (todas as organizações)",
  scope_global_label: "Global",
  scope_global_hint: "Escopo global: o interruptor que qualquer organização sem override próprio herda.",
  scope_org_hint: "As mudanças aqui criam um override para esta organização, que vence o interruptor global.",
  scope_catalog_error:
    "Não foi possível carregar o catálogo de organizações; os overrides podem mostrar IDs em vez de nomes.",
  scope_catalog_truncated:
    "Há mais organizações do que as listadas; digite para buscar todas. Alguns overrides podem mostrar o ID.",

  // KPI strip
  kpi_all: "Trilho × direção",
  kpi_disabled: "Em manutenção",
  kpi_overrides: "Com overrides",
  kpi_own_overrides: "Com override próprio",

  // Table / cards
  section_payins: "Cobranças (payins)",
  section_payouts: "Pagamentos (payouts)",
  th_rail: "Trilho",
  th_country: "País",
  th_status: "Estado",
  th_source: "Origem",
  th_overrides: "Overrides",
  direction_payin: "Cobranças",
  direction_payout: "Pagamentos",
  country_ar: "Argentina",
  country_br: "Brasil",
  hint_usdt_payin: "Venda de USDT",
  hint_usdt_payout: "Compra de USDT e recarga de cartões com pesos",
  country_co: "Colômbia",
  country_mx: "México",
  status_enabled: "Ativo",
  status_disabled: "Em manutenção",
  source_default: "Ativo por padrão",
  source_global_setting: "Ajuste global",
  source_global: "Herda do global",
  source_org_override: "Override da organização",
  overrides_count: "{{count}} overrides",
  overrides_count_one: "1 override",
  overrides_count_other: "{{count}} overrides",
  overrides_popover_hint: "Toque em uma organização para abrir sua visão e gerenciar seu override.",
  action_clear_override: "Remover override",
  empty_title: "Nenhum trilho para mostrar",
  empty_description: "Nenhum trilho corresponde ao filtro selecionado.",

  // Disable dialog (ligar é direto pelo switch)
  toggle_title_disable: "Colocar {{rail}} em manutenção",
  toggle_scope_global: "Esta mudança se aplica a todas as organizações.",
  toggle_scope_org: "Esta mudança cria um override apenas para a organização selecionada.",
  toggle_consequence_disable:
    "Operações novas neste trilho serão recusadas a partir de agora e o cliente verá um aviso de manutenção com um botão para nos escrever no WhatsApp. O que já está em andamento não é afetado e liquida normalmente.",
  toggle_currency_in_maintenance:
    "Com isso, todos os trilhos de {{currency}} ficam em manutenção. Converter para {{currency}} continua disponível: antes de converter, o cliente vê que para enviar esse saldo precisa falar com o suporte pelo WhatsApp.",
  toggle_surviving_overrides_title: "Overrides que continuam operando",
  toggle_surviving_overrides_text: "Estas organizações têm um override ligado que vence a manutenção global:",
  reason_label: "Motivo",
  reason_placeholder: "Ex.: incidente do trilho — rede indisponível",
  reason_required: "Informe o motivo da manutenção.",
  reason_internal_hint:
    "O motivo é de uso interno: apenas a equipe da Coloca o vê. O cliente vê um aviso de manutenção, sem o motivo.",
  toggle_cancel: "Cancelar",
  toggle_confirm_disable: "Colocar em manutenção",
  two_factor_required: "Para mudar o estado de um trilho você precisa ativar a verificação em duas etapas.",
  two_factor_description: "Mudar um trilho afeta os clientes que o usam: confirme com o seu segundo fator.",

  // Clear override dialog
  clear_title: "Remover o override",
  clear_description: "A organização volta a seguir o interruptor global (ou o estado padrão) deste trilho.",
  clear_both_directions:
    "Este override cobre ambas as direções: removê-lo afeta cobranças e pagamentos ao mesmo tempo.",
  clear_confirm: "Remover override",
  clear_cancel: "Cancelar",

  // Toasts / errors
  toast_enabled: "{{rail}} ativo.",
  toast_disabled: "{{rail}} em manutenção. Operações novas serão recusadas.",
  toast_override_cleared: "Override de {{rail}} removido.",
  error_load: "Não foi possível carregar o estado dos trilhos.",
  error_load_detail: "Verifique sua conexão e tente novamente.",
  error_retry: "Tentar novamente",
  error_save: "Não foi possível salvar a mudança.",
  error_no_write_permission: "Seu usuário não tem permissão de escrita sobre pagamentos.",
};
